$(document).on("turbolinks:load", () => {
  // $("#login-modal").modal("show");
  $("#incomplete-registration-modal").modal("show");
});
